import { render, staticRenderFns } from "./ActivationIndia.vue?vue&type=template&id=66b5a5da&scoped=true&"
import script from "./ActivationIndia.vue?vue&type=script&lang=js&"
export * from "./ActivationIndia.vue?vue&type=script&lang=js&"
import style0 from "./ActivationIndia.vue?vue&type=style&index=0&id=66b5a5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b5a5da",
  null
  
)

export default component.exports